import { useTechnicalDataScenarioContext } from "../context/TechnicalDataScenarioProvider";

export const useActiveScenarioName = () => {
  const { activeScenario } = useTechnicalDataScenarioContext();
  return activeScenario?.name;
};
